import { Button } from '@/components/atoms/Button';
import { Box, Fab, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Container = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(3),
  },
}));

export const StyledScoreCardMapContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  gap: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const MapContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '488px',
  borderRadius: theme.spacing(1),
  overflow: 'hidden',
  [theme.breakpoints.down('xmd')]: {
    height: '560px',
  },
  [theme.breakpoints.down('sm')]: {
    height: '360px',
  },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  height: '36px',
  padding: theme.spacing(1, 2.5),
  borderColor: theme.palette.action.active,
  color: theme.palette.text.primary,
  '&:hover': {
    borderColor: theme.palette.action.active,
    backgroundColor: theme.palette.action.hover,
  },
}));

export const StyledDivider = styled('hr')(({ theme }) => ({
  width: '100%',
  border: `1px solid ${theme.palette.divider}`,
  borderBottom: 'none',
}));

export const StyledChartLabelContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const StyledFab = styled(Fab)(() => ({
  width: '80px',
  height: '80px',
  position: 'fixed',
  bottom: 24,
  right: 24,
  zIndex: 1000,
  background: 'linear-gradient(180deg, #00C056 0%, #009933 100%)',
  '&:hover': {
    background: 'linear-gradient(180deg, #00C056 0%, #009933 100%)',
  },
}));

export const TitleHeader = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  padding: theme.spacing(3),
}));

export const MunicipalityAutocompleteContainer = styled(Box)(() => ({
  width: '100%',
  maxWidth: '432px',
}));

export const StyledChangeMunicipalityButton = styled(Button)(({ theme }) => ({
  width: '100%',
  maxWidth: 'fit-content',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '36px',
  gap: theme.spacing(1),
  padding: theme.spacing(1, 2.5),
  borderColor: theme.palette.action.active,
  color: theme.palette.text.primary,
  '&:hover': {
    borderColor: theme.palette.action.active,
    backgroundColor: theme.palette.action.hover,
  },
}));
